/* ทะเบียนวัสดุ (มีรูป) — ใช้เป็นตัวเลือกใน Template และใบเลือกวัสดุ */
import React, { useEffect, useState } from "react";
import { Col, Form, Image, Input, InputNumber, Row, Select } from "antd";
import CrudPage from "../../../components/ak/CrudPage";
import StatusTag from "../../../components/ak/StatusTag";
import ImageUpload from "../../../components/ak/ImageUpload";
import { MaterialService } from "../../../service/Ak.service";
import OptionService from "../../../service/Options.service";
import { fileUrl, formatMoney } from "../../../utils/util";

const opt = OptionService();
const money = { formatter: (v) => (v === undefined || v === null || v === "" ? "" : `${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")), parser: (v) => `${v}`.replace(/,/g, "") };
const UNIT_OPTIONS = ["ชิ้น", "ชุด", "ตร.ม.", "เมตร", "แผ่น", "กล่อง", "แกลลอน", "ถัง", "บาน", "จุด", "ดวง"].map((v) => ({ value: v, label: v }));

export default function MaterialPage() {
  const [cats, setCats] = useState([]);
  const [cat, setCat] = useState();

  useEffect(() => {
    opt.categories().then((r) => setCats(r.data?.data || []));
  }, []);

  return (
    <CrudPage
      title="วัสดุ"
      subtitle="วัสดุที่ให้ลูกค้าเลือก พร้อมรูปและราคาอ้างอิง"
      menu="master_material"
      rowKey="mat_code"
      service={MaterialService}
      addText="เพิ่มวัสดุ"
      modalWidth={760}
      extraParams={{ cat }}
      extraFilters={<Select allowClear placeholder="ทุกหมวด" value={cat} onChange={setCat} options={cats} style={{ width: 200 }} />}
      initialValues={{ unit: "ชิ้น" }}
      renderForm={(form, editing) => (
        <Row gutter={12}>
          <Col xs={24} md={8}>
            <Form.Item name="mat_code" label="รหัสวัสดุ" extra={editing ? null : "เว้นว่าง = ระบบออกรหัสให้"} rules={[{ pattern: /^[A-Za-z0-9._-]*$/, message: "ใช้ได้เฉพาะ A-Z 0-9 . _ -" }]}>
              <Input maxLength={30} disabled={!!editing} />
            </Form.Item>
          </Col>
          <Col xs={24} md={16}>
            <Form.Item name="mat_name" label="ชื่อวัสดุ" rules={[{ required: true, message: "กรอกชื่อวัสดุ" }]}>
              <Input maxLength={200} />
            </Form.Item>
          </Col>
          <Col xs={24} md={8}>
            <Form.Item name="cat_code" label="หมวด" rules={[{ required: true, message: "เลือกหมวด" }]}>
              <Select options={cats} showSearch optionFilterProp="label" />
            </Form.Item>
          </Col>
          <Col xs={24} md={8}>
            <Form.Item name="brand" label="ยี่ห้อ">
              <Input maxLength={100} />
            </Form.Item>
          </Col>
          <Col xs={24} md={8}>
            <Form.Item name="model" label="รุ่น">
              <Input maxLength={100} />
            </Form.Item>
          </Col>
          <Col xs={24} md={8}>
            <Form.Item name="color" label="สี / ลาย">
              <Input maxLength={100} />
            </Form.Item>
          </Col>
          <Col xs={24} md={8}>
            <Form.Item name="size" label="ขนาด">
              <Input maxLength={100} />
            </Form.Item>
          </Col>
          <Col xs={12} md={4}>
            <Form.Item name="unit" label="หน่วย">
              <Select options={UNIT_OPTIONS} showSearch />
            </Form.Item>
          </Col>
          <Col xs={12} md={4}>
            <Form.Item name="price" label="ราคา/หน่วย">
              <InputNumber min={0} style={{ width: "100%" }} {...money} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item name="image_path" label="รูปวัสดุ (ใช้โชว์ลูกค้าตอนเลือก)">
              <ImageUpload type="material" />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item name="remark" label="หมายเหตุ">
              <Input.TextArea rows={2} maxLength={2000} />
            </Form.Item>
          </Col>
          {editing && (
            <Col xs={24} md={8}>
              <Form.Item name="active_status" label="สถานะ">
                <Select options={[{ value: "Y", label: "ใช้งาน" }, { value: "N", label: "ปิดใช้งาน" }]} />
              </Form.Item>
            </Col>
          )}
        </Row>
      )}
      toPayload={(v) => ({ ...v, mat_code: v.mat_code || undefined })}
      columns={() => [
        { title: "", dataIndex: "image_path", width: 64, render: (v) => (v ? <Image src={fileUrl(v)} width={48} height={48} style={{ objectFit: "cover", borderRadius: 4 }} /> : <div className="ak-img-empty sm" />) },
        { title: "รหัส", dataIndex: "mat_code", width: 120 },
        { title: "ชื่อวัสดุ", dataIndex: "mat_name" },
        { title: "หมวด", dataIndex: "cat_name" },
        { title: "ยี่ห้อ / รุ่น", key: "brand", render: (_, r) => [r.brand, r.model].filter(Boolean).join(" ") || "-" },
        { title: "สี / ขนาด", key: "color", render: (_, r) => [r.color, r.size].filter(Boolean).join(" · ") || "-" },
        { title: "ราคา", dataIndex: "price", align: "right", render: (v, r) => (v !== null && v !== undefined ? `${formatMoney(v, 2)} / ${r.unit || "-"}` : "-") },
        { title: "สถานะ", dataIndex: "active_status", render: (v) => <StatusTag value={v} /> },
      ]}
    />
  );
}
